export default function getSceneByQuery (query) {
  const value = query ? query.scene : ''
  if (value === undefined || value === null) {
    return null
  }

  const scene = String(value).trim()
  if (!scene || scene.toLowerCase() === 'undefined' || scene.toLowerCase() === 'null') {
    return null
  }

  const sceneNumber = Number(scene)
  return isNaN(sceneNumber) ? null : sceneNumber
}



// WEBPACK FOOTER //
// ./src/utils/getSceneByQuery.js